module.exports = __webpack_public_path__ + "img/Metrics.5f0bd396.svg";